import React, { useEffect } from "react";
import styles from "./OccasionCatergory.module.css";
import BreadCrumb from "../../Components/Products/BreadCrumb/BreadCrumb";
import { useParams } from "react-router-dom";
import useCategoryStore from "../../Stores/useCategoryStore";
import useOccasionStore from "../../Stores/useOccasionStore";
import {handleImgError} from "../../Components/Shared/ImageError";
import NewPolaroid from "../../Components/Products/NewPolaroid";
import { ProductsAPI } from "../../Helpers/ConfigProvider";

function OccasionCatergory() {
  const { OccasionName } = useParams();

  const apiUrl = ProductsAPI;

  const {
    occasions,
    getOccasionByFriendlyName,
    selectedOccasion,
    loading,
    errors,
  } = useOccasionStore();

  useEffect(() => {
    // Fetch or set up data based on OccasionName if needed
    if (OccasionName) {
      const getData = async () => {
        await getOccasionByFriendlyName(OccasionName);
      };
      getData();
    }
  }, [OccasionName]);

  return (
    <div className={styles.OccasionCatergory}>
      {loading && <div>Loading occasion...</div>}
      <BreadCrumb
        Route="Occasions"
        ProductName={selectedOccasion ? selectedOccasion.Name : null
          
        }
      />
      {errors.length > 0 ? (
        <div className={styles.ErrorMessages}>an error occurred</div>
      ) : (
        <div className={styles.Occasion}> 
        <div className={styles.TitleDescription}>
          <div className={styles.Title}>
            {selectedOccasion ? selectedOccasion.Name : "Occasion"}
          </div>
          <div className={styles.Description}>
            {selectedOccasion
              ? selectedOccasion.Description
              : "Description of the occasion will be displayed here."}
          </div>
          </div>
          {/* <div className={styles.ImageContainer}>
            {selectedOccasion && selectedOccasion.Image ? (
              <img className={styles.Image} src={apiUrl + selectedOccasion.Image.src} alt={selectedOccasion.Image.alt} onError={handleImgError} />
            ) : null}
          </div> */}
          <div className={styles.HamperList}>
            {selectedOccasion && selectedOccasion.Hampers && selectedOccasion.Hampers.length > 0 ? (
              selectedOccasion.Hampers.map((hamper) => (
                <div key={hamper.Id} className={styles.HamperCard}>
                    <NewPolaroid
                        Id={hamper.Id}
                        Name={hamper.Name}
                        Images={new Array(hamper.Images)}
                        Price={hamper.Price}
                        FriendlyName={hamper.FriendlyName}
                        Route={`Occasions/${OccasionName}`}
                        Theme={selectedOccasion.Theme}
                    />
                    </div>
              ))
            ) : (
              <div>No hampers available for this occasion.</div>
            )}
          </div>
         {selectedOccasion && selectedOccasion.PerfectWith && selectedOccasion.PerfectWith.length > 0 ? (
            <div className={styles.PerfectWith}>
              <div className={styles.PerfectWithTitle}>Perfect With...</div>
              <div className={styles.PerfectWithList}>
                {selectedOccasion.PerfectWith.map((item) => (
                  <div key={item.Id} className={styles.PerfectWithItem}>
                    <NewPolaroid
                      Id={item.Product.Id}
                      Name={item.Product.Name}  
                      Images={item.Product.Images ?  (Array.isArray(item.Product.Images) ? item.Product.Images : [item.Product.Images]) : []}
                      Price={item.Product.Price}
                      FriendlyName={item.Product.FriendlyName}
                      Route={`Products${item.Category && item.Category.FriendlyName ? `/${item.Category.FriendlyName}` : ''}`}
                    />  
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>        
      )}
    </div>
  );
}

export default OccasionCatergory;
